import st from './Spinner.module.scss'

export const Spinner = ({ cn="" }) => {
    const cl = (st.spinner +' '+cn).trim()
    return (
        <svg className={cl} viewBox="0 0 50 50">
            <circle className={st.path} cx="25" cy="25" r="20" fill="none" strokeWidth="5"></circle>
        </svg>
    )
}
